import React from 'react';
import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItemOption,
  Flex,
} from '@chakra-ui/react';
import { MdExpandMore } from 'react-icons/md';
import { t } from '#i18n';

const GROUP_BY_OPTIONS = {
  AUTHOR: t('common.user.plural'),
  TEAM: t('common.team.plural'),
};

export const GroupBySelect = ({ groupBy, onChange }) => (
  <Flex alignItems="center" gap={3}>
    <p>{t('stats.statsFor')}</p>
    <Menu closeOnSelect>
      <MenuButton
        as={Button}
        aria-label="group-by-select"
        minWidth={32}
        backgroundColor="primary.400"
        borderColor="primary.300"
        variant="outline"
        fontWeight="normal"
        textAlign="left"
        rightIcon={<MdExpandMore />}
      >
        {GROUP_BY_OPTIONS[groupBy]}
      </MenuButton>
      <MenuList>
        {Object.entries(GROUP_BY_OPTIONS).map(([value, label]) => (
          <MenuItemOption
            key={value}
            value={value}
            isChecked={groupBy === value}
            onClick={() => onChange(value)}
          >
            {label}
          </MenuItemOption>
        ))}
      </MenuList>
    </Menu>
  </Flex>
);
